import { Dispatch } from "redux";
import SuiteApi from "./../api/SuiteApi";
import { fetchModuleCapabilitiesPending, fetchModuleCapabilitiesSuccess, fetchModuleCapabilitiesError } from '../redux/actions/ModuleCapabilitiesActions';

export function fetchModuleCapabilities() {
  return (dispatch: Dispatch) => {
    dispatch(fetchModuleCapabilitiesPending());
    SuiteApi.getModuleCapabilities()
      .then((modules) => {
        dispatch(fetchModuleCapabilitiesSuccess(modules));
      })
      .catch((error) => {
        dispatch(fetchModuleCapabilitiesError(error));
      });
  };
}
